module.exports = __webpack_public_path__ + "static/media/Location.2150eb2e.svg";